module.exports = __webpack_public_path__ + "img/img_027@2x.10386011.png";